import React from "react";

import Loader from "../loader/Loader";

interface LoaderProps {
    children?: React.ReactNode;
    className?: string;
    show?: boolean;
}

const LoaderFullScreen = ({children, show, className}: LoaderProps) => {
    return (
        <>
            {show &&
                <div className="loader-full-screen">
                    <Loader></Loader>
                </div>
            }
        </>
    );
};
export default LoaderFullScreen;
